import { useState, useEffect } from 'react';

/**
 * `useDarkMode` is a custom hook that manages dark mode state and persistence.
 */
const useDarkMode = () => {
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('darkMode') === 'true';
    });

    useEffect(() => {
        if (darkMode) {
            document.documentElement.setAttribute('data-theme', 'dark');
        } else {
            document.documentElement.removeAttribute('data-theme');
        }
        localStorage.setItem('darkMode', darkMode); // Save state
    }, [darkMode]);

    return [darkMode, setDarkMode];
};

export default useDarkMode;